"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var element_ui_1 = require("element-ui");
var rules_1 = require("./rules");
var error_message_1 = require("./error-message");
var vue_property_decorator_1 = require("vue-property-decorator");
// 引用一份，解决某些环境下调用了全局Vue.mixin后再调用原FormItem下的方法会造成调用栈溢出
var ElFormItemMethods = element_ui_1.FormItem
    .methods;
var ElFormItemVerifyComponent = /** @class */ (function (_super) {
    __extends(ElFormItemVerifyComponent, _super);
    function ElFormItemVerifyComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ElFormItemVerifyComponent_1 = ElFormItemVerifyComponent;
    // watch某值并修改该值本身会额外触发一次，性能影响不大，暂不做过滤了。后期可能会用其它方式拦截
    ElFormItemVerifyComponent.prototype.onValidateMessageChanged = function (msg) {
        if (this._verify && msg !== "") {
            var alias = this.alias || this.label || "该输入项";
            this.validateMessage = error_message_1.default.macroToValue(this.validateMessage, "alias", alias);
        }
    };
    ElFormItemVerifyComponent.prototype.onWatchChanged = function () {
        if (this._verify)
            this.validate("");
    };
    Object.defineProperty(ElFormItemVerifyComponent.prototype, "_verify", {
        get: function () {
            return this.verify !== undefined && this.prop;
        },
        enumerable: true,
        configurable: true
    });
    ElFormItemVerifyComponent.prototype.getRules = function () {
        var _this = this;
        if (!this._verify)
            return ElFormItemMethods.getRules.apply(this, arguments);
        var asyncVerifyRules = [];
        // 空检测
        var fieldValue = this.fieldValue;
        fieldValue =
            [undefined, null].indexOf(fieldValue) === -1 ? fieldValue + "" : "";
        if (this.space === undefined)
            fieldValue = fieldValue.trim();
        if (fieldValue === "") {
            asyncVerifyRules.push({
                validator: function (rule, val, callback) {
                    if (_this.canBeEmpty !== undefined || _this.minLength <= 0)
                        callback();
                    else
                        callback(Error(_this.emptyMessage || error_message_1.default.get("empty")));
                }
            });
        }
        else {
            // 合并普通规则
            var ruleGetters = rules_1.default();
            for (var name_1 in ruleGetters) {
                var ruleVal = this[name_1];
                if (ruleVal !== undefined)
                    asyncVerifyRules = asyncVerifyRules.concat(ruleGetters[name_1](ruleVal));
            }
            // 统一处理错误提示（代码块放在此处可以只针对普通规则）
            if (this.errorMessage !== undefined) {
                for (var _i = 0, asyncVerifyRules_1 = asyncVerifyRules; _i < asyncVerifyRules_1.length; _i++) {
                    var rule = asyncVerifyRules_1[_i];
                    rule.message = this.errorMessage;
                }
            }
            // 自定义校验方法置后
            if (typeof this.verify === "function")
                asyncVerifyRules.push({ validator: this.verify });
            // 当规则为空时，返回一个始终通过的规则来避免空检测错误无法清除
            // 也可以通过(this as any).clearValidate()的方式实现，不过不太好
            if (asyncVerifyRules.length === 0) {
                asyncVerifyRules.push({
                    validator: function (rule, val, callback) {
                        callback();
                    }
                });
            }
        }
        // 使elementUI可以检测到必填项从而展示*号
        asyncVerifyRules[0].required = this.canBeEmpty === undefined;
        return asyncVerifyRules;
    };
    // 兼容<2.0.0-beta.1
    ElFormItemVerifyComponent.prototype.clearValidate = function () {
        if (ElFormItemMethods.clearValidate) {
            ElFormItemMethods.clearValidate.apply(this, arguments);
        }
        else {
            this.validateState = "";
            this.validateMessage = "";
            this.validateDisabled = false;
        }
    };
    ElFormItemVerifyComponent.prototype.onFieldChange = function () {
        var fieldChange = this.fieldChange || ElFormItemVerifyComponent_1.fieldChange;
        if (!this._verify || fieldChange !== "clear")
            ElFormItemMethods.onFieldChange.apply(this, arguments);
        else if (this._verify && fieldChange === "clear")
            this.clearValidate();
    };
    var ElFormItemVerifyComponent_1;
    __decorate([
        vue_property_decorator_1.Prop([String, Function]),
        __metadata("design:type", Object)
    ], ElFormItemVerifyComponent.prototype, "verify", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "canBeEmpty", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "space", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "emptyMessage", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "errorMessage", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "alias", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", void 0)
    ], ElFormItemVerifyComponent.prototype, "watch", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], ElFormItemVerifyComponent.prototype, "fieldChange", void 0);
    __decorate([
        vue_property_decorator_1.Watch("validateMessage"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ElFormItemVerifyComponent.prototype, "onValidateMessageChanged", null);
    __decorate([
        vue_property_decorator_1.Watch("watch"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ElFormItemVerifyComponent.prototype, "onWatchChanged", null);
    ElFormItemVerifyComponent = ElFormItemVerifyComponent_1 = __decorate([
        vue_property_decorator_1.Component
    ], ElFormItemVerifyComponent);
    return ElFormItemVerifyComponent;
}(vue_1.default));
exports.default = ElFormItemVerifyComponent;
